import { render, staticRenderFns } from "./closureTemplates.vue?vue&type=template&id=bddf4a68"
import script from "./closureTemplates.vue?vue&type=script&lang=js"
export * from "./closureTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bddf4a68')) {
      api.createRecord('bddf4a68', component.options)
    } else {
      api.reload('bddf4a68', component.options)
    }
    module.hot.accept("./closureTemplates.vue?vue&type=template&id=bddf4a68", function () {
      api.rerender('bddf4a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/closureTemplates.vue"
export default component.exports